import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryCatalog"] */ "/app/src/components/products/CategoryCatalog.tsx");
